"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("styled-components");

var _universLight = _interopRequireDefault(require("./fonts/univers-light.woff"));

var _universLight2 = _interopRequireDefault(require("./fonts/univers-light.woff2"));

var _universRoman = _interopRequireDefault(require("./fonts/univers-roman.woff"));

var _universRoman2 = _interopRequireDefault(require("./fonts/univers-roman.woff2"));

var _universBold = _interopRequireDefault(require("./fonts/univers-bold.woff"));

var _universBold2 = _interopRequireDefault(require("./fonts/univers-bold.woff2"));

var _universBoldCond = _interopRequireDefault(require("./fonts/univers-bold-cond.woff"));

var _universBoldCond2 = _interopRequireDefault(require("./fonts/univers-bold-cond.woff2"));

var _universCond = _interopRequireDefault(require("./fonts/univers-cond.woff"));

var _universCond2 = _interopRequireDefault(require("./fonts/univers-cond.woff2"));

var _universBlack = _interopRequireDefault(require("./fonts/univers-black.woff"));

var _universBlack2 = _interopRequireDefault(require("./fonts/univers-black.woff2"));

var _hsdevilleRoman = _interopRequireDefault(require("./fonts/hsdeville-roman.woff"));

var _hsdevilleRoman2 = _interopRequireDefault(require("./fonts/hsdeville-roman.woff2"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var GlobalFonts = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @font-face {\n    font-family: \"univers-light\";\n    src: local(\"univers-light\"),\n      url(", ") format(\"woff2\"),\n      url(", ") format(\"woff\");\n  }\n\n  @font-face {\n    font-family: \"univers-roman\";\n    src: local(\"univers-roman\"),\n      url(", ") format(\"woff2\"),\n      url(", ") format(\"woff\");\n  }\n\n  @font-face {\n    font-family: \"univers-cond\";\n    src: local(\"univers-cond\"),\n      url(", ") format(\"woff2\"),\n      url(", ") format(\"woff\");\n  }\n\n  @font-face {\n    font-family: \"univers-bold\";\n    src: local(\"univers-bold\"),\n      url(", ") format(\"woff2\"),\n      url(", ") format(\"woff\");\n  }\n\n  @font-face {\n    font-family: \"univers-bold-cond\";\n    src: local(\"univers-bold-cond\"),\n      url(", ") format(\"woff2\"),\n      url(", ") format(\"woff\");\n  }\n\n  @font-face {\n    font-family: \"univers-black\";\n    src: local(\"univers-black\"),\n      url(", ") format(\"woff2\"),\n      url(", ") format(\"woff\");\n  }\n\n  @font-face {\n    font-family: \"hs-deville\";\n    src: local(\"hs-deville\"),\n      url(", ") format(\"woff2\"),\n      url(", ") format(\"woff\");\n  }\n"])), _universLight2.default, _universLight.default, _universRoman2.default, _universRoman.default, _universCond2.default, _universCond.default, _universBold2.default, _universBold.default, _universBoldCond2.default, _universBoldCond.default, _universBlack2.default, _universBlack.default, _hsdevilleRoman2.default, _hsdevilleRoman.default);
var _default = GlobalFonts;
exports.default = _default;